import * as React from 'react'
import { View } from 'react-native'
import { NeedCardView } from './NeedCard'

interface Props {
  length?: number
}

export const NeedsListLoader = ({ length = 25 }: Props) => {
  const fakeItems = Array.from(Array(length).keys())
  return (
    <>
      {fakeItems.map((item) => (
        <View
          key={item}
          style={{
            flex: 1,
            paddingHorizontal: 12,
            paddingVertical: 8,
          }}
        >
          <NeedCardView status="loading" />
        </View>
      ))}
    </>
  )
}
